/*
 * <hub-directory-finder> — directory articles, sections/hub-directory-finder.liquid.
 * Began as assets/hub-schools.js (the cooking schools page).
 *
 * Group links (#region-<handle>, #type-…, #speciality-…) and A–Z entries
 * (#<entry word>-<handle>, e.g. #school-roam-the-boot) are
 * ordinary anchors, so without this script they still jump there and :target
 * draws a card's ring. This adds the smooth scroll, moves focus to the target,
 * and on a school card shows a ring that fades after 2.4s, as in the design.
 *
 * The scroll offset for the sticky header and Hub sub-nav is the target's own
 * scroll-margin-top (hub-dir.css), so it is not recomputed here.
 */
if (!customElements.get('hub-directory-finder')) {
  customElements.define('hub-directory-finder', class extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      clearTimeout(this._timer);
    }

    _onClick(event) {
      const link = event.target.closest('a[data-hub-dir]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;

      event.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      target.focus({ preventScroll: true });
      history.replaceState(null, '', '#' + target.id);

      document.querySelectorAll('.hub-dir__card.is-selected').forEach((el) => el.classList.remove('is-selected'));
      clearTimeout(this._timer);
      if (!target.classList.contains('hub-dir__card')) return;
      target.classList.add('is-selected');
      this._timer = setTimeout(() => target.classList.remove('is-selected'), 2400);
    }
  });
}
